import React from "react";
import StarRating from "./StarRating";
import { Globe, FileText, ChevronDown } from "lucide-react";
import { useCompany } from "../context/CompanyContext";

export default function CompanyHeader() {
  const { company } = useCompany();
  return (
    <section className="bg-white border-b border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 pt-4 pb-2">
        <div className="text-[11px] text-gray-500 mb-3">Updated on {company.updatedOn}</div>
        <div className="flex flex-col md:flex-row gap-5">
          <div className="shrink-0">
            <div className="w-[80px] h-[80px] md:w-[120px] md:h-[120px] border border-gray-200 rounded-lg flex items-center justify-center bg-white p-2 md:p-3">
              {company.logo ? (
                <img
                  src={company.logo}
                  alt={company.name}
                  className="max-w-full max-h-full object-contain"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                    e.currentTarget.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                style={{
                  display: company.logo ? "none" : "flex",
                  backgroundColor: company.color,
                }}
                className="w-full h-full rounded-md items-center justify-center text-white font-black text-3xl"
              >
                {company.initials}
              </div>
            </div>
          </div>
          <div className="flex-1">
            <h1 className="text-[22px] md:text-[32px] font-bold text-gray-900 leading-tight">{company.name}</h1>
            <a
              href={`https://${company.url}`}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1 text-[#007a8a] hover:underline text-sm mt-1"
            >
              <Globe size={14}/> {company.url}
            </a>
            <div className="mt-3 flex items-center gap-3 flex-wrap">
              <div className="flex items-center gap-2">
                <StarRating value={company.rating} size={18}/>
                <span className="text-2xl font-bold text-gray-800">{company.rating}</span>
                <span className="text-sm text-gray-500">out of 5</span>
              </div>
            </div>
            <div className="mt-2 text-sm text-gray-600">
              Based on <span className="font-semibold text-gray-800">{company.totalReviews.toLocaleString()}</span> reviews from registered users.
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <button className="bg-[#e84e1c] hover:bg-[#d04515] transition-colors text-white font-semibold text-sm px-5 py-2.5 rounded-md flex-1 sm:flex-none min-w-[140px]">
                Submit review
              </button>
              <button className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium text-sm px-4 py-2.5 rounded-md flex items-center justify-center gap-1 flex-1 sm:flex-none">
                <FileText size={14}/> Is this your business?
              </button>
              <button className="bg-white border border-gray-300 hover:bg-gray-50 text-gray-700 font-medium text-sm px-4 py-2.5 rounded-md flex items-center justify-center gap-1">
                More <ChevronDown size={14}/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
